import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Context } from '../..';
import styles from './UserApplicationsPage.module.scss';
import { CertificationApplication } from '../../models/Certification';

const UserApplicationsPage: React.FC = () => {
  const { store } = useContext(Context);
  const [applications, setApplications] = useState<CertificationApplication[]>([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const data = await store.getUserApplications(store.user.id);
        if (data) {
          setApplications(data);
        }
        console.log(applications)
      } catch (error) {
        console.error('Помилка при завантаженні заявок', error);
      }
    };

    if (store.isAuth) {
      fetchApplications();
    }
  }, [store]);

  return (
    <div className={styles.applications}>
      <h1 className={styles['applications__header']}>Мої заявки на сертифікацію</h1>
      {applications.length > 0 ? (
        <div className={styles['applications__list']}>
          {applications.map((app) => (
            <div key={app.id} className={styles['applications__item']}>
              <p className={styles['applications__item-title']}>ISO №{app.certification.ISO} - {app.certification.name}</p>
              {app.certification.photo && (
                <img src={`${process.env.REACT_APP_BASE_URL}/images/${app.certification.photo}`} alt={app.certification.name} className={styles['applications__item-img']} />
              )}
              <p className={styles['applications__item-description']}>{app.status}</p>
              <p className={styles['applications__item-date']}>Дата подачі: {new Date(app.createdAt).toLocaleDateString()}</p>
              <div className={styles['result-block']}>
                {app.status === 'Відмовлено' && (
                  <>
                    <p>Причина відхилення: {app.refusal_reason}</p>
                    <Link to={`/certifications/${app.certification.id}/apply`} className={styles['resubmit-link']}>
                      Подати заявку наново 
                    </Link>
                  </>
                )}
                {app.status === 'Запрошено на екзамен' && (
                  <>
                    <p>Дата запрошення: {app.invitation_date}</p>
                    <p>Місце запрошення: {app.invitation_location}</p>
                    <p>Контактні дані: {app.contact_details}</p>
                  </>
                )}
                {app.status === 'Активний' && (
                  <p>Оцінка: {app.approvalScore}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className={styles['applications__no-items']}>У вас немає заявок на сертифікацію.</p>
      )}
    </div>
  );
};

export default observer(UserApplicationsPage);
